/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * @file  BehaviourTrendsStyle.jsx
 * Styles for behaviour trends card on difficult topic review
 */

import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import mixins from '../../../assets/styles/mixins.scss';

export const Root = styled(Box)({
  '&&': {
    border: `1px solid ${mixins.chalkWhiteFont}`,
    borderRadius: 16,
    padding: 16,
    backgroundColor: mixins.chalkWhiteFont,
    height: '100%',
    boxSizing: 'border-box'
  }
});

export const Title = styled(Typography)({
  '&&': {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight500,
    fontStyle: 'normal',
    fontSize: mixins.fontSize20,
    lineHeight: '28px',
    letterSpacing: '-0.4',
    color: mixins.color_text_primary,
    marginBottom: 16
  }
});

export const TrendsContainer = styled(Box)({
  '&&': {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  }
});

export const TrendItem = styled(Box)({
  '&&': {
    display: 'flex',
    alignItems: 'center',
    gap: 16
  }
});

export const PercentText = styled(Typography)({
  '&&': {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight600,
    fontStyle: 'normal',
    fontSize: mixins.fontSize16,
    lineHeight: '100%',
    color: mixins.color_text_primary
  }
});

export const TrendText = styled(Box)({
  '&&': {
    display: 'flex',
    flexDirection: 'column'
  }
});

export const ValueText = styled(Typography)({
  '&&': {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight500,
    fontStyle: 'normal',
    fontSize: mixins.fontSize14,
    lineHeight: mixins.lineHeight22,
    color: mixins.amethyst
  }
});

export const DescriptionText = styled(Typography)({
  '&&': {
    fontFamily: mixins.fontFamilyPlusSans,
    fontWeight: mixins.fontWeight400,
    fontStyle: 'normal',
    fontSize: mixins.fontSize12,
    lineHeight: mixins.lineHeight20,
    color: mixins.color_text_primary
  }
});
